import React from "react";
export default function VaultNew({ fill }) {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4676_36795)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.0625 5.06045C3.0625 4.16628 3.78737 3.44141 4.68155 3.44141H20.4435C21.3376 3.44141 22.0625 4.16628 22.0625 5.06045V18.9652C22.0625 19.8594 21.3376 20.5843 20.4435 20.5843H19.87V21.4414H17.6777V20.5843H7.44695V21.4414H5.25464V20.5843H4.68155C3.78737 20.5843 3.0625 19.8594 3.0625 18.9652V5.06045ZM16.0625 14.4414C17.1671 14.4414 18.0625 13.546 18.0625 12.4414C18.0625 11.3368 17.1671 10.4414 16.0625 10.4414C14.9579 10.4414 14.0625 11.3368 14.0625 12.4414C14.0625 13.546 14.9579 14.4414 16.0625 14.4414ZM16.0625 16.4414C18.2716 16.4414 20.0625 14.6505 20.0625 12.4414C20.0625 10.2323 18.2716 8.44141 16.0625 8.44141C13.8534 8.44141 12.0625 10.2323 12.0625 12.4414C12.0625 14.6505 13.8534 16.4414 16.0625 16.4414ZM5.4079 9.80713C5.28366 9.67557 5.0625 9.7635 5.0625 9.94445V14.0812C5.0625 14.2622 5.28366 14.3501 5.4079 14.2185L7.36138 12.1502C7.43417 12.0731 7.43417 11.9526 7.36138 11.8755L5.4079 9.80713Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_4676_36795">
          <rect
            width="24"
            height="24"
            fill={fill}
            transform="translate(0.0625 0.441406)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
